<template>


  <div class="rows rows-contenant">

    <div class="row" v-for="contenant in contenants.filtredContenants" v-bind:key="contenant.id">
      <div class="col-xs-2">
        <span class="title-item">Numéro du contenant</span>
        <span class="text-item">{{ contenant.reference }}</span>
      </div>
      <div class="col-xs-1">
        <span class="title-item">Type</span>
        <span class="text-item">{{ contenant.typeContenant | collecteType }}</span>
      </div>
      <div class="col-xs-3">
        <span class="title-item">Arrondissement / Secteur</span>
        <span
          class="text-item">{{ contenant.arrondissement_id | arrondissementName }} / {{ contenant.secteur_id | secteurName }}</span>
      </div>
      <div class="col-xs-5 adresse">
        <span class="title-item">Adresse</span>
        <span class="text-item">{{ contenant.adresse }}</span>
      </div>
      <div class="col-xs-1">
        <span class="title-item">Nombre de collectes</span>
        <span class="text-item">{{ contenant.nombreDeCollecte ? contenant.nombreDeCollecte : 0 }} </span>
      </div>
      <div class="col-xs-1">
        <span class="title-item">Moyenne</span>
        <span class="text-item">{{ contenant.tauxDeRemplissage }} </span>
      </div>
      <div class="col-xs-2 last-date-collecte">
        <span class="title-item">Dernière collecte</span>
        <span class="text-item">{{ formatDate(contenant.lastModif) }}</span>
      </div>
      <div class="col-xs-2">
        <div class="actions-contenants">
          <a class="action-edit" v-on:click="$emit('edit', contenant)">
<!--            <span class="tooltiptext">-->
<!--            Action non autorisée</span>-->
            <img src="../../../../static/img/edit-icon.svg">
          </a>
          <a class="action-delete right-separator" v-on:click="$emit('delete', contenant)">
<!--            <span class="tooltiptext">-->
<!--            Action non autorisée</span>-->
            <img src="../../../../static/img/delete-icon.svg">
          </a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import {secteurName} from '../../../filters'

export default {
  computed: {
    ...mapState([
      'implentationContenants',
      'maitrise',
      'contenants'
    ]),
  },
  mounted: async function () {
    await this.$store.dispatch('fetchSecteursOfVille')
    this.$store.dispatch('fetchContenantsOfVille', {arg: 'contenants'})    //console.log("collecte => " , this.state.implentationContenants.data)
    this.$store.dispatch('fetchAllContenants')    //console.log("collecte => " , this.state.implentationContenants.data)
  },
  methods: {
    formatDate: function (date) {
      if (date !== undefined && date !== null) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      } else {
        return '-'
      }
    }
  },
}
</script>

<style lang="scss">
.action-delete .tooltiptext {
  visibility: hidden;
  width: 210px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.action-delete:hover .tooltiptext {
  visibility: visible;
}

.action-edit .tooltiptext {
  visibility: hidden;
  width: 210px;
  background-color: black;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding-left: 20px;
  right: 50%;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.action-edit:hover .tooltiptext {
  visibility: visible;
}

.actions-contenants {
  margin-right: -15px;
  margin-left: -15px;

  a {
    display: block;
    height: 5rem;
    line-height: 5rem;
    width: 35%;
    float: right;
    text-align: center;
    cursor: pointer;

    &.action-edit {
      background-color: #D9DEF2;
    }

    &.action-select {
      background-color: #aadc14;
    }

    &.action-delete {
      background-color: #D9DEF2;
    }

    &.right-separator {
      border-right: 1px solid white;
    }

    img {
      display: inline-block;
      height: 3rem;
      max-width: 70%;
    }
  }
}

/* .rows-contenant{
  margin-top: 3%;
} */
.last-date-collecte {
  margin-right: -5%;
}

.adresse {
  max-width: 20% !important;
}
</style>



// WEBPACK FOOTER //
// CollectesList.vue?5f084934